export const Font = (langCode: string) => {
  // const chineseLang = ['zh-tw', 'zh-cn']
  // const isChineseLang = chineseLang.indexOf(langCode) > -1

  let mainFont = 'EB Garamond, serif'
  const playfairDisplayBold = 'Playfair Display Bold, serif'
  const bodyFont = 'Open Sans, sans-serif'
  switch (langCode) {
    case 'zh-cn':
    case 'zh-tw':
      mainFont = 'source-han-sans-traditional, sans-serif'
      break
    case 'ja':
      mainFont = 'source-han-sans-japanese, sans-serif'
      break
    case 'il':
      mainFont = 'Assistant Regular'
      break
    case 'lv':
      mainFont = 'Georgia, Times New Roman, Times, serif'
      break
    default:
      mainFont = 'EB Garamond, serif'
  }

  return {
    mainFont,
    bodyFont,
    playfairDisplayBold,
  }
}

export default Font
